import { takeEvery } from 'redux-saga/effects';

import * as actionTypes from 'store/modules/listing/actionTypes';
import { updateUserRoles } from './utils';

export default function* listenSaveSuccess() {
  yield takeEvery(actionTypes.SAVE_SUCCESS, updateUserRoles);
}
